import { render, staticRenderFns } from "./RelativeDonorsTab.vue?vue&type=template&id=6fb215a4"
import script from "./RelativeDonorsTab.vue?vue&type=script&lang=ts"
export * from "./RelativeDonorsTab.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports